module.exports = __webpack_public_path__ + "img/ice-cream.f4d319b3.svg";